import { render } from "./settings-layout.vue?vue&type=template&id=63def849&scoped=true"
import script from "./settings-layout.js?vue&type=script&lang=js&external"
export * from "./settings-layout.js?vue&type=script&lang=js&external"

import "./settings-layout.css?vue&type=style&index=0&id=63def849&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63def849"]])

export default __exports__